import { ChangeDetectorRef, Component, DestroyRef, ElementRef, HostListener, OnInit, Renderer2, ViewChild, ChangeDetectionStrategy } from '@angular/core';
import { takeUntilDestroyed } from '@angular/core/rxjs-interop';
import { MsalBroadcastService, MsalService } from '@azure/msal-angular';
import { EventMessage, EventType, AuthenticationResult } from '@azure/msal-browser';
import { filter } from 'rxjs';
import { HeaderService } from '../../services/header.service';
import { AppInitService } from '../../services/app-init.service';
import { MenuItem } from 'primeng/api';

@Component({
  selector: 'app-header',
  templateUrl: './header.component.html',
  styleUrls: ['./header.component.scss'],
  changeDetection: ChangeDetectionStrategy.Eager,
  standalone: false
})
export class HeaderComponent implements OnInit {


  currentShowDropdown: boolean = false;
  showSubSubMenu: boolean = false;
  userLogin: any;
  ProjectName: string | null = '';
  customerFactoryName: string = '';
  projectOrganizationName: string = '';
  ProjectId: string | null = '';
  menuItems: MenuItem[] = [
    {
      label: 'Logout',
      icon: 'pi pi-sign-out',
      command: () => this.logout()
    }
  ];
  menuTop = 0;
  menuRight = 8;

  get userInitials(): string {
    const username: string = this.userLogin || '';
    const nameParts = username.split('@')[0].split(/[.\s_-]+/).filter(Boolean);
    const initials = nameParts.length > 1
      ? `${nameParts[0][0]}${nameParts[1][0]}`
      : nameParts[0]?.slice(0, 2);
    return initials?.toUpperCase() || 'NA';
  }

  constructor(
    private authService: MsalService,
    private msalBroadcastService: MsalBroadcastService,
    private headerService: HeaderService,
    private readonly appInitService: AppInitService,
    private readonly cdr: ChangeDetectorRef,
    private readonly destroyRef: DestroyRef,

  ) {


  }

  ngOnInit() {
    this.appInitService.projectName$
      .pipe(takeUntilDestroyed(this.destroyRef))
      .subscribe(() => {
        this.userLogin = sessionStorage.getItem('username');
        const customername = sessionStorage.getItem('customername') ?? '';
        const factoryname = sessionStorage.getItem('factoryname') ?? '';
        const projectname = sessionStorage.getItem('projectname') ?? '';
        const iotestorganizationname = sessionStorage.getItem('iotestorganizationname') ?? '';
        this.customerFactoryName = `${customername} / ${factoryname}`;
        this.projectOrganizationName = `${projectname}  ${iotestorganizationname}`;
        this.ProjectName = `${this.customerFactoryName}`;
        this.cdr.markForCheck();
      });
    this.headerService.reciveProjectIdObservable.subscribe(ProjectId => {

      this.ProjectId = sessionStorage.getItem('projectId');
    });
    this.msalBroadcastService.msalSubject$
      .pipe(
        filter((msg: EventMessage) =>
          msg.eventType === EventType.LOGIN_SUCCESS ||
          msg.eventType === EventType.ACQUIRE_TOKEN_SUCCESS ||
          msg.eventType === EventType.SSO_SILENT_SUCCESS
        ),
      )
      .subscribe((result: EventMessage) => {
        const payload = (result as any).payload;
        if (payload?.account?.username) {
          this.userLogin = payload.account.username;
          sessionStorage.setItem('username', this.userLogin);
        }
      });

    this.userLogin = sessionStorage.getItem('username');



  }

  @ViewChild('profileMenu') profileMenu!: ElementRef;
  @ViewChild('profileButton') profileButton!: ElementRef;

  toggleDropdown() {
    this.currentShowDropdown = !this.currentShowDropdown;

    if (this.currentShowDropdown) {
      const rect = this.profileButton.nativeElement.getBoundingClientRect();
      this.menuTop = rect.bottom + 0;
      this.menuRight = window.innerWidth - rect.right;
    }
  }
  @HostListener('document:click', ['$event'])
  onClickOutside(event: MouseEvent): void {
    const clickedInsideMenu = this.profileMenu?.nativeElement.contains(event.target);
    const clickedButton = this.profileButton?.nativeElement.contains(event.target);

    if (!clickedInsideMenu && !clickedButton) {
      this.currentShowDropdown = false;
    }
  }



  logout() {

    this.authService.logoutRedirect({
      postLogoutRedirectUri: "/",
    });
    sessionStorage.clear();

  }

}



